import { CarrierSubmissionClient } from 'clients';
import { QueryKeys } from 'enums';
import { CarrierSubmission, CarrierSubmissionSearchFilter, CarrierSubmissionUpdate } from 'types';
import { UseQueryBaseRetrieveOptions, UseQueryBaseSearchOptions } from './query/types';
import { useMutate, useQueryMutation } from './query/useMutate';
import { useQueryRetrieve, useQuerySearch } from './query/useQuery';

export function useRetrieveCarrierSubmission(props: UseQueryBaseRetrieveOptions<CarrierSubmission>) {
  const { id, queryOptions, enabled } = props;
  return useQueryRetrieve<CarrierSubmission, CarrierSubmission, CarrierSubmissionClient>({
    queryKey: QueryKeys.CarrierSubmission,
    clientClass: CarrierSubmissionClient,
    id,
    enabled,
    queryOptions,
  });
}

interface UpdateCarrierSubmissionParams {
  id: string;
  data: CarrierSubmissionUpdate;
}

export function useMutateCarrierSubmission() {
  const { client } = useMutate<CarrierSubmission, CarrierSubmission, CarrierSubmission, CarrierSubmissionClient>({
    queryKey: QueryKeys.CarrierSubmission,
    clientClass: CarrierSubmissionClient,
  });

  const updateCarrierSubmission = useQueryMutation<CarrierSubmission, UpdateCarrierSubmissionParams>(
    ({ id, data }) => client.updateCarrierSubmission(id, data),
    QueryKeys.CarrierSubmission,
  );

  return { updateCarrierSubmission };
}

export function useSearchCarrierSubmissions(
  props: UseQueryBaseSearchOptions<CarrierSubmission, CarrierSubmissionSearchFilter> = {},
) {
  const { filter, queryOptions, enabled } = props;
  return useQuerySearch<CarrierSubmission, CarrierSubmission, CarrierSubmissionClient, CarrierSubmissionSearchFilter>({
    queryKey: QueryKeys.CarrierSubmissions,
    clientClass: CarrierSubmissionClient,
    enabled,
    filter,
    queryOptions,
  });
}
